import { Flex, Input, Select, Typography } from "antd";
import { countryCodes } from "Features/Finance/LoanEligibility/Phone";
import { useState } from "react";

export const PhoneNumber = ({ phoneNumber, setPhoneNumber }) => {
  const { Title } = Typography;
  const [selectedCountryCode, setSelectedCountryCode] = useState(
    countryCodes[0].code + " " + countryCodes[0].dialCode
  );
  const [phoneNumberWithoutCountryCode, setPhoneNumberWithoutCountryCode] =
    useState("");

  return (
    <Flex vertical justify="flex-start" align="flex-start">
      <Title style={{ fontSize: "18px" }}>Phone number</Title>
      <Flex align="center" wrap style={{ width: "80%", marginTop: "10px" }}>
        <Select
          style={{ flex: 1 }}
          options={countryCodes.map((country) => ({
            label: country.code + " " + country.dialCode,
            value: country.code + " " + country.dialCode,
          }))}
          value={selectedCountryCode}
          onChange={(value) => setSelectedCountryCode(value)}
        />
        <Input
          style={{ flex: 4 }}
          placeholder="Enter your phone number"
          value={phoneNumberWithoutCountryCode}
          type="number"
          onChange={(e) => {
            setPhoneNumberWithoutCountryCode(e.target.value);
            setPhoneNumber(selectedCountryCode + e.target.value);
          }}
        />
      </Flex>
    </Flex>
  );
};
